module.exports = __webpack_public_path__ + "media/images/twitter-bird-17043f7113a08e257bf3f176090f14e1.svg";